import { immerable } from "immer";

// Models
import Call from "./call";

export default class CallDDR extends Call {
  [immerable] = true;

  subCall: Call;

  constructor(options: any) {
    super(options);

    this.subCall = options.subCall;
  }
}
